// Shared by BrandAssets.jsx (library management) and SignatureForm.jsx/
// Campaigns.jsx (insert-from-library pickers) so both label asset_type the
// same way. Values are { tr, en } entries — resolve with i18n's t()/pick().
export const BRAND_ASSET_TYPE_LABELS = {
  logo: { tr: 'Logo', en: 'Logo' },
  icon: { tr: 'İkon', en: 'Icon' },
  banner: { tr: 'Banner Görseli', en: 'Banner Image' },
  other: { tr: 'Diğer', en: 'Other' },
};

// Pixel width to bake into the <img width="..."> attribute when a picker
// inserts a brand asset into signature/campaign HTML — deliberately a real
// HTML attribute, NOT a CSS style="max-width:100%" percentage. Found
// 2026-09-23: a picked asset rendered fine in the browser-based editor
// preview but showed as a broken-image placeholder in real Outlook sends
// and the taskpane preview — classic Outlook's Word-based rendering engine
// can't reliably lay out an <img> with only a percentage width and no
// pixel attribute, unlike every OTHER image token in this app
// ({{ProfilePhoto}}, {{VCardQR}}, {{BrandLogo}} — see
// signaturePlaceholders.js), which all already use a plain width="N"
// attribute and don't have this problem. Height is left unset so it scales
// proportionally, same convention {{BrandLogo}} already uses.
export const BRAND_ASSET_INSERT_WIDTH = { logo: 160, icon: 32, banner: 400, other: 200 };
